import { useState } from 'react';

export const useActionButtonsUiState = () => {
    const [isAnswerModalOpen, setIsAnswerModalOpen] = useState<boolean>(false);
    const [isAiModalOpen, setIsAiModalOpen] = useState<boolean>(false);
    const [isReportModalOpen, setIsReportModalOpen] = useState<boolean>(false);
    const [reportSummaryRefreshToken, setReportSummaryRefreshToken] = useState(0);
    const [pickedReviewsAnswer, setPickedReviewsAnswer] = useState<string>('');
    const [isAllPickLoading, setIsAllPickLoading] = useState<boolean>(false);
    const [isGroupsMergeLoading, setIsGroupsMergeLoading] = useState<boolean>(false);

    return {
        isAnswerModalOpen,
        setIsAnswerModalOpen,
        isAiModalOpen,
        setIsAiModalOpen,
        isReportModalOpen,
        setIsReportModalOpen,
        reportSummaryRefreshToken,
        bumpReportSummaryRefreshToken: () => {
            setReportSummaryRefreshToken((current) => current + 1);
        },
        pickedReviewsAnswer,
        setPickedReviewsAnswer,
        isAllPickLoading,
        setIsAllPickLoading,
        isGroupsMergeLoading,
        setIsGroupsMergeLoading,
    };
};
